import { DesignProp, GeneralProp } from "../PropCategories";

export const fontFamily = {
  prop: "style-attribute",
  name: "Font Family",
  nameI18n: "builder_ui.prop_type.styles.font_family",
  category: [DesignProp, GeneralProp],
  type: "font-picker",
  defaultValue: "Inter",
} as const;
